// Carry Roll PDF export — jspdf + autotable yardage cards (11.5).

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import type { BagEntry } from '@carry-roll/shared-types';
import { convertDistance, type DistanceUnit } from '@carry-roll/shared-logic';

export function exportYardageCardPdf(
  bag: BagEntry[],
  title = 'Carry Roll Yardage Card',
  distanceUnit: DistanceUnit = 'm',
): void {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text(title, 14, 18);

  const conv = (m: number) => convertDistance(m, distanceUnit);
  const u = distanceUnit === 'yd' ? 'yd' : 'm';

  autoTable(doc, {
    startY: 26,
    head: [['Club', 'Loft (°)', `Carry (${u})`, `Total (${u})`]],
    body: bag.map((b) => [
      b.clubName,
      b.loftDeg.toFixed(1),
      Math.round(conv(b.carryM)).toString(),
      Math.round(conv(b.totalM)).toString(),
    ]),
  });

  doc.save('carry-roll-yardage-card.pdf');
}
